import React from "react";
import { GridColumnHeaderParams } from "@mui/x-data-grid";
import { Typography } from "@mui/material";

const HeaderText = (params: GridColumnHeaderParams) => {
    return (
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
            {params.colDef.headerName}
        </Typography>
    );
};

export default HeaderText;